import React from 'react'
import ReactModal from 'react-modal'
import { inject, observer } from 'mobx-react'
import styled from 'styled-components'

import FixedCloseButton from '~/components/modals/FixedCloseButton'
import MODAL_STYLES from '~/components/modals/styles'

import SectionHeader from '~/components/Pages/SectionHeader'
import Spacer from '~/components/Spacer'
import EvidenceModalButtons from './EvidenceModalButtons'

import GreenButton from "~/components/traffic-tickets/steps/GreenButton"

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 140px;
  max-height: 60px;
`

const ButtonRowContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
`

@inject(all => ({
  isMobile: all.store.ui.isMobile
}))
@observer
class EvidenceModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showModal: false
    }
  }

  openModal = () => this.setState({ showModal: true })

  hideModal = () => this.setState({ showModal: false })

  render() {
    const { isMobile, ticket } = this.props
    return (
      <>
        <ReactModal
          closeTimeoutMS={300}
          isOpen={this.state.showModal}
          style={
            isMobile
              ? MODAL_STYLES.mobile.generalNoPadding
              : MODAL_STYLES.desktop.generalNoPadding
          }
          contentLabel="Login to your winit account"
          onRequestClose={this.hideModal}
        >
          <Spacer mobile={16} desktop={0} />
          <FixedCloseButton 
            color={this.props.isMobile ? 'black' : 'white'} 
            onClick={this.hideModal} 
          />
          <SectionHeader title="Upload your evidence" />
          <Spacer mobile={32} desktop={32} />
          <ButtonRowContainer>
            <EvidenceModalButtons ticket={ticket} />
          </ButtonRowContainer>
          <Spacer mobile={32} desktop={32} />
          <ButtonRowContainer>
            <ButtonContainer> 
              <GreenButton text="Proceed" onClick={this.hideModal} />
            </ButtonContainer>
          </ButtonRowContainer>
          <Spacer mobile={32} desktop={32} />
        </ReactModal>
        <this.props.opener onClick={this.openModal} />
      </>
    )
  }
}

export default EvidenceModal